import React, { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { aplicarMarcaBody } from "../utils/aplicarMarcaBody";

const BrandPreviewContext = createContext();

export const BrandPreviewProvider = ({ children }) => {
  const [previewBrand, setPreviewBrand] = useState(null);

  useEffect(() => {
    if (previewBrand) {
      aplicarMarcaBody(previewBrand);
    }
  }, [previewBrand]);

  return (
    <BrandPreviewContext.Provider value={{ previewBrand, setPreviewBrand }}>
      {children}
    </BrandPreviewContext.Provider>
  );
};

BrandPreviewProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useBrandPreview = () => {
  const context = useContext(BrandPreviewContext);
  if (!context) {
    throw new Error("useBrandPreview must be used within a BrandPreviewProvider");
  }
  return context;
};
